<div class="row" *ngIf="list?.length > 0;">
  <div class="col-md-12 grid-margin stretch-card">
    <div class="card card-fit">
      <div class="card-header">
        <div class="row w-100">
          <div class="col-12 d-flex justify-content-between align-items-start">
            <h2 class="card-title">{{ title }}</h2>
          </div>
        </div>
      </div>

      <div class="card-body">
        <ng-container *ngIf="isLoading; else datatableBlock">
          <ng-container *ngTemplateOutlet="loadingComponent"></ng-container>
        </ng-container>

        <ng-template #datatableBlock>
          <ng-container *ngIf="list?.length > 0; else emptyState">
            <div class="table-responsive">
              <ngx-datatable [rows]="list" [count]="count" [limit]="queryParams.top"
                [offset]="queryParams.skip / queryParams.top" (page)="onPage($event)" (sort)="onSort($event)"
                class="ngx-datatable-custom" [rowHeight]="'auto'" [columnMode]="'force'" [headerHeight]="56"
                [footerHeight]="56" [externalPaging]="false" [externalSorting]="true"
                [sorts]="currentSort ? [currentSort] : []">

                <ng-container *ngFor="let col of columns">
                  <ngx-datatable-column *ngIf="col.prop !== 'employeeManagerJobTitle'" [name]="col.name" [prop]="col.prop"
                    [sortable]="col.sortable !== false" [width]="col.width">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <ng-container *ngIf="col.prop === 'employeeManagerName'; else defaultCell">
                        <div class="d-flex flex-column">
                          <span class="font-weight-bolder">{{ row.employeeManagerName | titlecase }}</span>
                          <span class="text-muted small">{{ row.employeeManagerJobTitle| titlecase }}</span>
                        </div>
                      </ng-container>

                      <ng-template #defaultCell>
                        <ng-container [ngSwitch]="col.action">

                          <ng-container *ngSwitchCase="'view'">
                            <button class="btn btn-sm p-0 d-flex align-items-center text-primary"
                              (click)="handleViewFeedback(row)">
                              <i data-feather="eye"></i> Visualizar
                            </button>
                          </ng-container>

                          <ng-container *ngSwitchDefault>
                            {{ resolveValue(row, col.prop) }}
                          </ng-container>
                        </ng-container>
                      </ng-template>
                    </ng-template>
                  </ngx-datatable-column>
                </ng-container>
              </ngx-datatable>
            </div>

            <div class="card-footer">
              <app-paginator [count]="count" [queryParams]="queryParams" (query)="loadFeedbacks()" type="squared"
                class="flex-1" [filter]="queryParams.filter">
              </app-paginator>
            </div>
          </ng-container>
        </ng-template>

        <ng-template #emptyState>
          <div class="text-center py-4 text-muted">Não há registros para exibir.</div>
        </ng-template>

        <ng-template #loadingComponent>
          <div class="card card-fit card-table shadow mt-2">
            <div class="card-body pt-2">
              <div class="flex flex-1 gap-2 p-1 flex-column justify-content-center align-items-center">
                <span class="spinner-border text-primary spinner-border-lg mr-1"></span>
                <span>Carregando</span>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>